<template>
    <div class="downloadBox">
        <div class="imgBox">
            <el-image :src="previewUrl[0]" :preview-src-list="previewUrl"></el-image>
        </div>
        <div class="btnBox">
            <!--<button class="avtionBtn" @click="preview">预览</button>-->
            <button class="avtionBtn" @click="idcardDownload">下载</button>
            <button class="avtionBtn" @click="editBtn" v-if="downloadStatus">修改信息</button>
            <button class="avtionBtn" @click="againTranslation">重新翻译</button>
        </div>
        <el-dialog title="修改信息" :visible.sync="editEngMsg" width="900px">
            <inputEdit :editData="editMsgDialog" :chooseType="chooseType"/>
            <div class="footer">
                <button class="avtionBtn" @click="editEngMsg=false">取消</button>
                <button class="sureavtionBtn" @click="engMsgSubmit">确定</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {downloadImg, idcardEditInfo} from "../../api/idcard";
    import inputEdit from "./inputEdit";
    import {baseHost,imgPreview, paymentHost} from "../../plugins/host";

    export default {
        name:"download",
        props:["previewUrl","chooseType","recordId","fileName"],
        components:{inputEdit},
        data(){
            return {
                editEngMsg:false,
                editMsgDialog:{},
                newpreviewUrl:"",
                newfileName:"" ,
                downloadStatus: true
            }
        },
        methods:{
            idcardDownload(){
                var side = this.chooseType ? "front" : "back";
                this.$axios(downloadImg(this.recordId, 'idcard',side))
                    .then(res=>{
                            var reader = new FileReader();
                            reader.readAsText(res.data, 'utf-8');
                            var self = this;
                            reader.onload = function () {
                                try{
                                    var resData = JSON.parse(reader.result);
                                    if (resData.code == 0) {
                                        // 是否VIP
                                        if(resData.data.is_vip){
                                            var url;
                                            // 直接支付
                                            url = `${paymentHost()}/cashier?from=cert&to=id_card&side=${side}&step=2&id=${self.recordId}&type=download`;
                                        }else{
                                            // 跳转至VIP特权页面
                                            url = `${paymentHost()}/tips?from=cert&to=id_card&side=${side}&step=2&id=${self.recordId}&type=download`;
                                        }
                                        window.location.href = url;
                                    }
                                }catch (e) {
                                    const blob = new Blob([res.data]);
                                    let fileName = self.fileName;
                                    if ('download' in document.createElement('a')) { // 非IE下载
                                        const elink = document.createElement('a');
                                        elink.download = fileName;
                                        elink.style.display = 'none';
                                        elink.href = window.URL.createObjectURL(blob);
                                        document.body.appendChild(elink);
                                        elink.click();
                                        window.URL.revokeObjectURL(elink.href);// 释放URL 对象
                                        document.body.removeChild(elink);
                                        // 下载后清除数据
                                        localStorage.removeItem(`idcardEnData${self.$route.query.id}`)
                                        this.downloadStatus = false;
                                    } else { // IE10+下载
                                        navigator.msSaveBlob(blob, fileName)
                                    }
                                }

                            }
                    })
                    .catch(error=>{
                        console.log(error)
                        this.$message.error("出现了未知错误")
                    })
            },
            engMsgSubmit(){
                this.loading = true;
                var Bid = this.$route.query.id;
                var side = this.$route.query.side;
                var engData = JSON.parse(localStorage.getItem(`idcardEnData${Bid}`));
                engData.is_edit = true;
                this.$axios(idcardEditInfo(engData))
                    .then(res=>{
                        if(res.data.code === 0){
                            this.loading = false;
                            this.newpreviewUrl = [imgPreview() + '/license' + res.data.data.translation];
                            this.newfileName = res.data.data.filename;     // 下载记录文件名
                            // 清除本地存储数据
                            localStorage.removeItem(`idcard${Bid}`);
                            // 保存译后数据， 下载时清楚 translation_data
                            localStorage.setItem(`idcardEnData${Bid}`, JSON.stringify(res.data.data.translation_data));
                            this.editEngMsg = false;
                            this.$emit("changePreviewURL",this.newpreviewUrl)
                        }
                    })
                    .catch(error=>{
                        this.loading = false;
                    })
            },
            editBtn(){
                var Bid = this.$route.query.id;
                this.editMsgDialog = JSON.parse(localStorage.getItem(`idcardEnData${Bid}`));
                this.editEngMsg = true;
            },
            againTranslation(){
                // 重新翻译， 因为编辑和预览地址栏中带有信息 所以需要用Window来跳转
                this.$emit("clearImg",this.chooseType);
                window.location.href = baseHost() + '/id_card'
            }
        },
        created() {
            if(parseInt(this.$route.query.step) === 2){     // preview page
                if(!localStorage.getItem('idcardEnData'+this.$route.query.id)){
                    this.downloadStatus = false;
                }
            }
            if(this.$route.query.type && this.$route.query.type == 'download'){
                this.idcardDownload()
            }
        },
    }
</script>

<style>
    .imgBox{
        width: 940px;
        height: 400px;
        border: solid 1px #eee;
        border-radius: 5px;
        margin-left: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .imgBox img{
        width: 80%;
        height: 80%;
    }
    .btnBox{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 50px;
    }
    .avtionBtn{
        color: #d82a22;
        border: solid 1px #d82a22;
        padding: 5px 30px;
        margin-right: 50px;
    }
    .sureavtionBtn{
        color: #fff;
        background: #d82a22;
        border: solid 1px #d82a22;
        padding: 5px 30px;
    }
    .footer{
        text-align: center;
    }
</style>
